var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgDownArrow = function SvgDownArrow(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 33 76",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.183.452v73.5m0 0 16-14m-16 14-15-14",
    stroke: "#fff",
    strokeWidth: 2
  })));
};

export { SvgDownArrow as ReactComponent };
export default __webpack_public_path__ + "33c61e457b44c3c1e08ac0d9afe3bd50.svg";